var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tail-describe"},[_vm._m(0),_c('div',{staticClass:"notice-content",style:(_vm.customWidth ? {width: _vm.customWidth} : '')},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"sp icontishishuoming",staticStyle:{"font-size":"12px"}})])
}]

export { render, staticRenderFns }